module.exports = __webpack_public_path__ + "img/quill-refresh-hover.ee46bf76.svg";